<template lang="">
  <div>
    <v-dialog v-model="isOpenDialog" width="620px" scrollable>
      <BaseBodyDialog 
        :title="`SỬA CHI TIẾT KHOẢN ${titleType.toUpperCase()}`"
        :loading="loading"
        @close="cancel"
        @save="save"
      >
        <v-form class="mt-6" ref="form" flat v-model="valid" lazy-validation>
          <v-row cols="12">
            <v-col>
              <h3>1. Thông tin cơ bản</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" v-if="$route.name === 'head-fees'">
              <v-autocomplete
                v-model="collectionApply"
                clear-icon="mdi-close"
                :items="collections"
                item-text="title"
                item-value="id"
                label="Nhóm"
                :loading="loading"
                clearable
                outlined
                dense
                return-object
                required
                class="required font-size"
                :rules="[$rules.required]"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="title"
                :label="$route.meta.title"
                :placeholder="$route.meta.title"
                outlined
                required
                dense
                class="required font-size"
                :rules="[$rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="$route.name !== 'head-fees'">
            <v-col cols="6">
              <v-autocomplete
                :value="headFeeApply"
                @input="handelChangeCollection"
                clear-icon="mdi-close"
                :items="headFees"
                item-text="title"
                item-value="id"
                label="Áp dụng với khoản phí thu/đóng"
                :loading="loading"
                clearable
                outlined
                dense
                return-object
                required
                class="required font-size"
                :rules="[$rules.required]"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="collectionApply"
                clear-icon="mdi-close"
                :items="collections"
                item-text="title"
                item-value="id"
                label="Nhóm"
                :loading="loading"
                append-icon=""
                clearable
                outlined
                dense
                return-object
                required
                disabled
                class="required font-size"
                :rules="[$rules.required]"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row cols="12">
            <v-col cols="12">
              <v-textarea v-model="note" outlined dense name="input-7-3" label="Ghi chú" rows="3"></v-textarea>
            </v-col>
          </v-row>
          <div>
            <v-row cols="12">
              <v-col>
                <h3>2. Thông tin hiển thị</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="shortName"
                  label="Tên hiển thị ngắn"
                  placeholder="Tên sẽ được hiển thị tại Chi tiết hoá đơn"
                  outlined
                  dense
                  hide-details="auto"
                  class=" font-size"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="rank"
                  label="Ưu tiên hiển thị"
                  placeholder="Thứ tự hiển thị tại Chi tiết hoá đơn"
                  outlined
                  dense
                  class=" font-size"
                  :rules="[$rules.isNumber]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="subNote"
                  outlined
                  dense
                  name="input-7-3"
                  label="Ghi chú hiển thị"
                  placeholder="Ghi chú sẽ được hiển thị tại Chi tiết hoá đơn"
                ></v-textarea>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </BaseBodyDialog>
    </v-dialog>
  </div>
</template>
<script>
import { inputRules } from '../../../plugins/rule'
import { mapActions, mapState } from 'vuex'
import BaseBodyDialog from '../../../components/basic/dialog/BaseBodyDialog.vue'

export default {
  components: {
    BaseBodyDialog
  },
  data() {
    return {
      isOpenDialog: false,
      valid: true,
      loading: false,
      title: '',
      category: 'custom',
      note: '',
      subNote: '',
      tags: '',
      rank: '',
      shortName: '',
      rules: inputRules,
      headFeeApply: '',
      collectionApply: '',
      headFees: [],
      collections: []
    }
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['headFee', 'router', 'isSubFee']),
    titleType() {
      return this.$route.meta.title.replace('Chi tiết khoản', '')
    }
  },
  methods: {
    ...mapActions('tuitonFeeHeadFee', ['updateHeadFees', 'fetchHeadFees']),
    ...mapActions('tuitionFeeCollection', ['fetchCollections']),
    async openDialog() {
      this.$loading.active = true
      await this.setData()
      this.$loading.active = false
      this.isOpenDialog = true
    },
    cancel() {
      this.$refs.form.reset()
      this.isOpenDialog = false
    },
    async setData() {
      this.title = this.headFee.title
      this.note = this.headFee.note
      this.subNote = this.headFee.metadata && this.headFee.metadata.subNote
      this.headFees = await this.fetchHeadFees({ type: 'normal' })
      this.collections = await this.fetchCollections()
      this.headFeeApply = this.headFee.head_fee_apply && this.headFee.head_fee_apply.id
      this.collectionApply = this.headFee.head_fee_collection && this.headFee.head_fee_collection.id
      this.rank = this.headFee.rank || 0
      this.shortName = this.headFee.metadata && this.headFee.metadata.shortName
    },
    validate() {
      return this.$refs.form.validate()
    },
    handelChangeCollection(value) {
      this.headFeeApply = value && value.id
      this.collectionApply = value ? value.head_fee_collection.id : ''
    },
    async save() {
      this.loading = true
      if (this.validate()) {
        this.isBtnSave = true
        let defaultParams = {
          title: this.title,
          head_fee_apply: this.headFeeApply
        }
        let params = this.headFee.category === 'custom' ? defaultParams : {}
        const payload = {
          id: this.headFee.id,
          data: {
            ...params,
            note: this.note,
            rank: this.rank ? +this.rank : 0,
            head_fee_collection: this.collectionApply,
            metadata: { shortName: this.shortName, subNote: this.subNote }
          }
        }
        await this.updateHeadFees(payload)
        this.cancel()
      }
      this.loading = false
    }
  }
}
</script>
<style lang="css" scoped>
h3 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #212121;
}
.head_fee_title {
  margin: -10px 0;
}
.head_fee_title p {
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  color: #797979;
  margin: 15px 0 10px 0;
}
.head_fee_title h5 {
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #212121;
}
.font-size {
  font-size: 13px;
}
</style>
